var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_924_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.93582 8.53906C1.03775 8.4375 1.03774 8.33594 1.13967 8.23438L3.1782 6.20312C3.58591 5.79688 4.19747 5.79688 4.60518 6.20312C5.01288 6.60938 5.01288 7.21875 4.60518 7.625L4.29939 7.92969H6.94948C7.56104 7.92969 7.96875 8.33594 7.96875 8.94531C7.96875 9.55469 7.56104 9.96094 6.94948 9.96094H4.29939L4.60518 10.2656C5.01288 10.6719 5.01288 11.2812 4.60518 11.6875C4.40132 11.8906 4.09554 11.9922 3.89169 11.9922C3.68784 11.9922 3.38206 11.8906 3.1782 11.6875L1.13967 9.65625C1.03774 9.55469 0.93582 9.45312 0.93582 9.35156C0.833893 9.04687 0.833893 8.84375 0.93582 8.53906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90123 11.9764C6.51228 11.9764 6.91964 12.3834 6.91964 12.9941V14.0118C6.91964 14.6225 7.32701 15.0296 7.93806 15.0296H8.95647V6.27703C8.95647 4.95397 9.7712 3.83446 10.8915 3.42736L12.5209 2.81672H7.93806C7.32701 2.81672 6.91964 3.22382 6.91964 3.83446V4.8522C6.91964 5.46284 6.51228 5.86993 5.90123 5.86993C5.29018 5.86993 4.88281 5.46284 4.88281 4.8522V3.83446C4.88281 2.10431 6.20675 0.78125 7.93806 0.78125H18.1222C18.2241 0.78125 18.3259 0.78125 18.4277 0.883024C18.5296 0.883024 18.6314 0.984797 18.6314 0.984797L18.7333 1.08657C18.8351 1.08657 18.9369 1.18834 18.9369 1.29012V1.39189C19.0388 1.39189 19.1406 1.49367 19.1406 1.59544V16.0473C19.1406 16.4544 18.8351 16.8615 18.5296 16.9633L11.808 19.5076C11.6044 19.6094 11.2988 19.6094 11.0951 19.6094C10.6878 19.6094 10.2804 19.5076 9.97489 19.2023C9.46568 18.7952 9.05831 18.1845 9.05831 17.5739V17.065H8.0399C6.30859 17.065 4.98465 15.742 4.98465 14.0118V12.9941C4.88281 12.4852 5.29018 11.9764 5.90123 11.9764ZM17.1038 15.3349V3.22382L11.7062 5.25929C11.2988 5.46284 10.9933 5.86993 10.9933 6.27703V17.5739L17.1038 15.3349Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_924_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.20fa2e0c786fb06e1a0b14035aa9d60f.svg";
export { ForwardRef as ReactComponent };